import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import {
  Box,
  ButtonBase,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

const methodSx = {
  width: "100%",
  minHeight: 132,
  p: 2.25,
  border: "1px solid #dfe3ea",
  borderRadius: 2,
  alignItems: "flex-start",
  justifyContent: "flex-start",
  textAlign: "left",
  transition: "border-color 160ms ease, background-color 160ms ease, box-shadow 160ms ease",
  "&:hover, &:focus-visible": {
    borderColor: "#7567e8",
    bgcolor: "#f8f7ff",
    boxShadow: "0 4px 14px rgba(79, 70, 180, 0.1)",
  },
};

const iconSx = {
  width: 42,
  height: 42,
  display: "grid",
  placeItems: "center",
  flexShrink: 0,
  borderRadius: 1.5,
  bgcolor: "#f0edff",
  color: "#6658dc",
  "& svg": { fontSize: 23 },
};

export const OssOrderCreateMethodDialog = ({ open, onClose, onManual, onAiUpload }) => (
  <Dialog
    open={open}
    onClose={onClose}
    maxWidth="sm"
    fullWidth
    PaperProps={{ sx: { borderRadius: 2, overflow: "hidden" } }}
  >
    <DialogTitle sx={{ px: 2.75, py: 2.25, pr: 7, borderBottom: "1px solid #e5e7eb" }}>
      <Typography component="h2" sx={{ fontSize: 19, fontWeight: 800, color: "#202938" }}>
        주문 등록
      </Typography>
      <Typography sx={{ mt: 0.5, fontSize: 13, color: "#687282" }}>
        주문을 등록할 방식을 선택하세요.
      </Typography>
      <IconButton
        aria-label="닫기"
        onClick={onClose}
        size="small"
        sx={{ position: "absolute", top: 17, right: 18, color: "#687282" }}
      >
        <CloseRoundedIcon />
      </IconButton>
    </DialogTitle>

    <DialogContent sx={{ p: "22px !important", bgcolor: "#fafbfc" }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}>
        <ButtonBase onClick={onManual} sx={methodSx}>
          <Stack direction="row" spacing={1.75} alignItems="flex-start">
            <Box sx={iconSx}><EditNoteRoundedIcon /></Box>
            <Box>
              <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#202938" }}>직접 입력</Typography>
              <Typography sx={{ mt: 0.75, fontSize: 12.5, lineHeight: 1.55, color: "#687282" }}>
                주문과 품목 정보를 직접 입력합니다.
              </Typography>
            </Box>
          </Stack>
        </ButtonBase>

        <ButtonBase onClick={onAiUpload} sx={methodSx}>
          <Stack direction="row" spacing={1.75} alignItems="flex-start">
            <Box sx={iconSx}><AutoAwesomeRoundedIcon /></Box>
            <Box>
              <Typography sx={{ fontSize: 15, fontWeight: 800, color: "#202938" }}>AI 업로드</Typography>
              <Typography sx={{ mt: 0.75, fontSize: 12.5, lineHeight: 1.55, color: "#687282" }}>
                발주서를 분석해 주문 정보를 자동으로 준비합니다.
              </Typography>
            </Box>
          </Stack>
        </ButtonBase>
      </Stack>
    </DialogContent>
  </Dialog>
);
